import { Row, Col, Button } from 'react-bootstrap';

interface PageHeaderProps {
  startAIMatchJob: () => Promise<void>;
  onReviewAIMatched: () => void;
  exportToGoogleSheet: () => Promise<void>;
  isStartingJob: boolean;
  isExporting: boolean;
  hasRunningJob: boolean;
  hasRunningExportJob: boolean;
}

export const PageHeader = ({
  startAIMatchJob,
  onReviewAIMatched,
  exportToGoogleSheet,
  isStartingJob,
  isExporting,
  hasRunningJob,
  hasRunningExportJob,
}: PageHeaderProps) => (
  <Row className="mb-4">
    <Col>
      <h1>Match Status</h1>
    </Col>
    <Col className="text-end d-flex justify-content-end">
      <Button
        variant="primary"
        onClick={async () => {
          await startAIMatchJob();
        }}
        disabled={isStartingJob || hasRunningJob}
        className="me-2"
      >
        {hasRunningJob ? 'Job in progress...' : 'Trigger AI Competitor Product Match Job'}
      </Button>
      <Button variant="outline-primary" onClick={onReviewAIMatched} className="me-2">
        Start review AI matched product
      </Button>
      <Button
        variant="success"
        onClick={async () => {
          await exportToGoogleSheet();
        }}
        disabled={isExporting || hasRunningExportJob}
      >
        {hasRunningExportJob ? 'Export job in progress...' : 'Export to Google Sheet'}
      </Button>
    </Col>
  </Row>
);
